import React, {useEffect, useState} from 'react';
import { PDFViewer, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import  background  from '../../assets/certificate.png';
import {APIGetPlan} from "../../api/plans/Plans";
import {useParams} from "react-router";
import {HiChevronLeft} from "react-icons/hi2";

export const PlanCertificate = () => {
	// Create styles
	const styles = StyleSheet.create({
		page: {
			flexDirection: 'column',
			backgroundColor: '#ffffff'
		},
		section: {
			margin: 10,
			padding: 10,
			flexGrow: 1,
			fontSize: "12pt",
		},
		headline: {
			fontSize: "32pt",
			fontWeight: "800",
			top: 30,
			left: 350,
		},
		headline2: {
			fontSize: "24pt",
			fontWeight: 200,
			top: 50,
			left: 100,
			width: 600,
			textAlign:"center"

		},
		description: {
			fontSize: "11pt",
			top: 80,
			left: 100,
			width: 600,
			color:"#666",
			lineHeight: 1.56,
			textAlign:"center"
		},
		description2: {
			fontSize: "11pt",
			top: 100,
			left: 100,
			width: 600,
			color:"#666",
			lineHeight: 1.56,
			textAlign:"center"

		},
		checkSum: {
			top: 129,
			left: 240,
			fontSize: "15pt",
			fontWeight:'bold'
		},
		date: {
			top: 280,
			left: 230,
		},
		backgroundImage: {
			position: 'absolute',
			top: 10,
			left: 10,
			zIndex: -1,
			width: '100%',
			height: '100%',
		},
		backgroundImage1: {
			position: 'absolute',
			top: 114,
			left: 22,
			zIndex: 0,
			width: 778,
			opacity:0.5

		},
	});
	const {id} = useParams();
	const [plan, setPlan] = useState(null);

	useEffect(() => {
		APIGetPlan(id).then(function(result) {
			setPlan(result?.[0]);
		});
	}, [id]);



	// Create Document Component
	return (
		<div className={"mx-auto w-full max-w-7xl"}>
			<div className={"text-base m-5 mt-16 mb-16   leading-7 text-gray-600"}>
				<div className="mt-2 md:flex md:items-center md:justify-between">
					<div className="min-w-0 flex-1">
						<h2 className="text-2xl flex font-normal leading-7 text-gray-900 sm:truncate  sm:tracking-tight">
							<a href={"/"}><HiChevronLeft  className={"text-3xl mr-2"} /></a> {plan?.name}
						</h2>
					</div>
				</div>
			</div>
			<PDFViewer className={"w-full px-6"} style={{height:"calc(100vh - 265px)"}}>
				<Document>
					<Page size="A4" orientation={"landscape"} style={styles.page}>
						<View style={styles.section}>
							<Image src={background} style={styles.backgroundImage} />
							<Text style={styles.headline}>Zertifikat</Text>
							<Text style={styles.headline2}>{plan?.name}</Text>
							<Text style={styles.description}>Dieses Zertifikat, bestätigt die vollständigkeit des genannten XPlans durch die Bau.Land.XPlan GBR.</Text>
							<Text style={styles.description2}>Die Vollständigkeit des dem Zertifikat zugrunde liegenden XPlans kann unter www.xplanung24.de/xplan/verification/{plan?.certificateShortId}{plan?.certificateHash} überprüft werden. Sollte im Besitz der einer XPLAN GML sein,so können Sie die Vollständigkeit unter https://www.xplanung24.de/solutions/xplan-certification verifizieren.</Text>
							<Text style={styles.checkSum}>{plan?.certificateShortId}{plan?.certificateHash}</Text>
							<Text style={styles.date}>09.05.2024</Text>
						</View>
					</Page>
				</Document>
			</PDFViewer>
		</div>
	);
}


